import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconShoppingBag2"><Path d="M15.25 7.75V6C15.25 4.20507 13.7949 2.75 12 2.75C10.2051 2.75 8.74998 4.20507 8.74998 6V7.75M7.72716 21.25H16.2728C18.1047 21.25 19.5089 19.6225 19.2404 17.8104L18.1293 10.3104C17.9114 8.83936 16.6487 7.75 15.1617 7.75H8.83828C7.35122 7.75 6.08859 8.83936 5.87066 10.3104L4.75955 17.8104C4.49109 19.6225 5.89525 21.25 7.72716 21.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconShoppingBag2;
